// extracted by mini-css-extract-plugin
export default {"container":"bancos_container__Q4GCU","tabla_bancos":"bancos_tabla_bancos__EyKPT","banco":"bancos_banco__EeRFA"};